<template>
  <div style="padding: 20px; background: rgb(221, 225, 230); border: 1px solid rgb(204, 204, 204)">
    <v-card class="mb-4" v-if="list_access">
      <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
        <div class="col-md-12">
          <div class="col-md-12" style="background: white">
            <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
            <v-divider class="mt-0"></v-divider>

            <div class="row pt-2">
              <div class="col-md-3">
                <v-text-field v-model="filters.date_from" density="comfortable" type="date" name="date_from" label="Desde" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="filters.date_to" density="comfortable" type="date" name="date_to" label="hasta" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacen" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox v-if="!isClient()" v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox
                  v-model="filters.product"
                  density="comfortable"
                  name="product"
                  item-title="label"
                  item-value="id"
                  :items="products_minify"
                  label="Producto"
                  autocomplete="off"
                  :disabled="disabled"
                  :loading="loading_products"
                  clearable
                ></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox
                  v-model="filters.document_types"
                  density="comfortable"
                  name="document_types"
                  item-title="name"
                  item-value="id"
                  :items="documents_types"
                  label="Tipo de Documento"
                  autocomplete="off"
                  :disabled="disabled"                  
                  multiple
                  clearable
                  chips
                ></v-combobox>
              </div>

              <div class="col-md-6 pt-2" style="display: flex; justify-content: end">
                <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
                <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <v-card v-if="list_access">
      <v-card-title>
        <v-row align="center" class="mt-1">
          <v-col>
            <span>{{ page_title }}</span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>

      <!-- v-if="list_access" -->

      <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.ingreso_date }}</td>
            <td>{{ item.almacen_name }}</td>
            <td>{{ item.asn }}</td>
            <td>{{ item.asn_external_ref }}</td>
            <td>{{ item.document_type_name }}</td>
            <td>{{ item.client_name }}</td>
            <td>
              <div class="font-weight-medium">
                <b>{{ item.lpn }}</b>
              </div>
            </td>
            <td>
              <div>
                <div class="text-body-2">{{ item.product_name }}</div>
                <span class="text-caption text-grey-600 d-block">SKU: {{ item.product_sku }}</span>
              </div>
            </td>
            <td>
              <div
                v-if="
                  item.expiration_date ||
                  item.lote ||
                  item.serie ||
                  item.storage_units_amount ||
                  item.quality_name ||
                  (isAliasEnabled('descriptivo_1') && item.descriptivo_1) ||
                  (isAliasEnabled('descriptivo_2') && item.descriptivo_2) ||
                  (isAliasEnabled('descriptivo_3') && item.descriptivo_3)
                "
              >
                <div v-if="item.expiration_date" class="attribute-row">
                  <span class="attribute-label">Vencimiento:</span>
                  <span class="attribute-value">{{ item.expiration_date }}</span>
                </div>
                <div v-if="item.lote" class="attribute-row">
                  <span class="attribute-label">Lote:</span>
                  <span class="attribute-value">{{ item.lote }}</span>
                </div>
                <div v-if="item.serie" class="attribute-row">
                  <span class="attribute-label">Serie:</span>
                  <span class="attribute-value">{{ item.serie }}</span>
                </div>
                <div v-if="item.storage_units_amount" class="attribute-row">
                  <span class="attribute-label">Almacenamiento:</span>
                  <span class="attribute-value">{{ item.storage_units_amount }}</span>
                </div>
                <div v-if="item.quality_name" class="attribute-row">
                  <span class="attribute-label">Calidad:</span>
                  <span class="attribute-value">
                    <v-chip size="x-small" color="primary">{{ item.quality_name }}</v-chip>
                  </span>
                </div>
                <div v-if="isAliasEnabled('descriptivo_1') && item.descriptivo_1" class="attribute-row">
                  <span class="attribute-label">{{ getAliasName("descriptivo_1") }}:</span>
                  <span class="attribute-value">{{ item.descriptivo_1 }}</span>
                </div>
                <div v-if="isAliasEnabled('descriptivo_2') && item.descriptivo_2" class="attribute-row">
                  <span class="attribute-label">{{ getAliasName("descriptivo_2") }}:</span>
                  <span class="attribute-value">{{ item.descriptivo_2 }}</span>
                </div>
                <div v-if="isAliasEnabled('descriptivo_3') && item.descriptivo_3" class="attribute-row">
                  <span class="attribute-label">{{ getAliasName("descriptivo_3") }}:</span>
                  <span class="attribute-value">{{ item.descriptivo_3 }}</span>
                </div>
              </div>
              <span v-else>-</span>
            </td>
            <td>
              <v-chip v-if="item.product_status_name" size="small" :color="getStatusColorByName(item.product_status_name)">
                <b>{{ item.product_status_name }}</b>
              </v-chip>
              <span v-else>-</span>
            </td>
            <td class="text-center">
              <div class="quantity-display">
                <span class="quantity-value">{{ item.base_amount }}</span>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { reportsService } from "@/libs/ws/reportsService";
import { documentsTypeService } from "@/libs/ws/documentsTypeService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import { productoService } from "@/libs/ws/productoService";
import UserTypeConstant from "@/constants/user_type";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
export default {
  components: {},
  mixins: [GenericMixin, RolMixin, ExportMixin, AliasMixin],
  data() {
    return {
      service: reportsService,
      page_title: "Detalle de ingresos",
      userTypeConstant: UserTypeConstant,
      user_type: null,
      headers: [],
      filters: {
        date_from: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        almacen: null,
        client: null,
        product: null,
        document_types: [],
      },

      documents_types: [],
      almacenes: [],
      clients: [],
      products_minify: [],
      loading_products: false,
    };
  },
  mounted() {
    this.loadAliasMap().then(() => {
      this.initializeHeaders(); // Se llama luego para que exista el mapa de alias
    });

    this.user_type = localStorage.getItem("user_type");
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadClientes();
    this.loadProductsMinify();
    this.loadDocumentTypes();
  },
  methods: {
    loadDocumentTypes() {
      documentsTypeService
        .filter({ order_type: "IN" })
        .then((response) => {
          this.documents_types = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    initializeHeaders() {
      this.headers = [
        {
          title: "Fecha",
          align: "left",
          sortable: true,
          value: "ingreso_date",
          visible: true,
        },
        {
          title: "Almacen",
          align: "left",
          sortable: true,
          value: "almacen_name",
          visible: false,
        },
        {
          title: "ASN",
          align: "left",
          sortable: true,
          value: "asn",
          visible: false,
        },
        {
          title: "Referencia externa",
          align: "left",
          sortable: true,
          value: "asn_external_ref",
          visible: false,
        },
        {
          title: "Tipo de Documento",
          align: "left",
          sortable: true,
          value: "document_type_name",
          visible: true,
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          value: "client_name",
          visible: false,
        },
        {
          title: "LPN",
          align: "left",
          sortable: true,
          value: "lpn",
          visible: true,
        },
        {
          title: "Producto",
          align: "left",
          sortable: true,
          value: "product_name",
          visible: true,
        },
        {
          title: "Atributos",
          align: "left",
          sortable: false,
          value: "attributes",
          visible: true,
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          value: "product_status_name",
          visible: true,
        },
        {
          title: "Cantidad",
          align: "center",
          sortable: true,
          value: "base_amount",
          visible: true,
        },
      ];

      // Recorro los headers y saco el cliente si el usuario es el cliente
      this.headers = this.headers.filter((header) => {
        if (header.visible_for_client || header.visible_for_client == undefined) {
          return true;
        }
        return !this.isClient();
      });
    },
    loadClientes() {
      if(this.isClient()){
        return;
      }
      
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    getFilterParams() {
      const params = { ...this.filters };
      if (this.filters.product && this.filters.product.sku) {
        params.sku = this.filters.product.sku;
      }
      delete params.product;
      return params;
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      reportsService
        .ingresosDetalle(param)
        .then((response) => {
          //this.setHeader();
          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    exportFile() {
      var param = { ...this.getFilterParams() }; // Copia de this.filters
      param["export"] = true;
      this.exportExcel(Constant.SECTION_REPORTS + "/ingresos-detalle", param, "Ingresos-Detalle.xlsx");
    },
    loadProductsMinify() {
      this.loading_products = true;
      productoService
        .list_minify()
        .then((response) => {
          this.products_minify = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_products = false;
        });
    },
    getStatusColorByName(statusName) {
      if (!statusName) return "primary";

      const statusLower = statusName.toLowerCase();
      if (statusLower.includes("disponible")) return "success";
      if (statusLower.includes("bloqueado")) return "warning";
      if (statusLower.includes("cuarentena")) return "info";
      if (statusLower.includes("vencido")) return "error";
      return "primary";
    },
  },
};
</script>

<style scoped>
.attribute-row {
  display: flex;
  align-items: center;
  padding: 1px 0;
  font-size: 0.875rem;
}

.attribute-label {
  font-weight: 500;
  width: auto;
  flex-shrink: 0;
  color: #666;
}

.attribute-value {
  font-weight: 400;
  color: #333;
  margin-left: 8px;
}

.quantity-display {
  display: flex;
  justify-content: center;
  align-items: center;
}

.quantity-value {
  font-weight: bold;
  font-size: 1rem;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  min-width: 60px;
  text-align: center;
}

.nowrap {
  white-space: nowrap;
}
</style>
